import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Tab } from '@mui/material';
import { SidebarAccordion } from 'src/components/accordion';
import { SwitchButtonWidget } from 'src/components/widget';

import { CodThankyouKnownMopProps } from './CODThankYouForm.interface';
import { KNOWN_USER_TYPES, KnownUserTabs } from './constants';

export const CodThankyouKnownMop = (props: CodThankyouKnownMopProps) => {
  const handleSwitchButton = (val: unknown) => {
    props.handleOnChange(
      `${props.customerPath}.mop`,
      val ? { background: '' } : undefined,
    );
  };

  return (
    <TabContext value={props.activeTab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={(_, val) => props.onChangeActiveTab(val)}>
          {KnownUserTabs.map(({ label, value }, index) => {
            return (
              <Tab
                disableRipple
                label={label}
                key={index}
                value={value}
                sx={{
                  width: '50%',
                  textTransform: 'none',
                  fontSize: '1rem',
                }}
              />
            );
          })}
        </TabList>
      </Box>
      <TabPanel
        data-testid={KNOWN_USER_TYPES.knownUser}
        value={KNOWN_USER_TYPES.knownUser}
        sx={{ p: 0, flex: 1, overflowY: 'auto' }}>
        <SidebarAccordion items={props.items} />
      </TabPanel>
      <TabPanel value={KNOWN_USER_TYPES.mopKnownUser} sx={{ p: 0 }}>
        <Grid sx={{ px: 3, pt: 3 }}>
          <SwitchButtonWidget
            value={props.isMopEnabled}
            onChange={handleSwitchButton}
          />
        </Grid>
        {props.isMopEnabled && (
          <SidebarAccordion items={[props.backgroundItem]} />
        )}
      </TabPanel>
    </TabContext>
  );
};
